import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { Route, Switch, Redirect } from 'react-router-dom';
import { connect } from 'react-redux';
import _ from 'lodash';
import classnames from 'classnames';
import { API } from '@service';
import AppHeader from './appHeader';
import AppFooter from './appFooter';
import { getRoutes } from './routes';
import { Loading } from '@components';
import actions from '@flux/action';
import { setSessionStorage, getSessionStorage } from '@utils/windowUtil';
import { isValidProjectId } from '@utils/common';
import { formatUserLocalDate } from '@utils/widget';
import {
  getProjectInfoFromLocation,
  getValueFromSearchParam,
} from '@utils/history';
import { isEmailVerifiedOrBypassed } from '@utils/emailVerificationBypass';
import SiderBar from './appSiderBar';

// import '@style/layout.scss';
// import '@style/Comment.scss';
// import '@style/Notification.scss';
import '../styles/layout.scss';
import '../styles/Comment.scss';
import '../styles/Notification.scss';
// import PendoIO from '@utils/pendo';
// import login from '@flux/action/login';
import checkLogin from './check_login';
// import CommentProvider from '@components/CommentCenter/components/CommentProvider';
import NotificationProvider from '../ddvComment/notificationProvider/NotificationProvider';
import CommentProvider from '../ddvComment/components/CommentProvider';
import {
  getCommentStatus,
  updateCommentStatus,
  getProjectMember,
  checkProfileStatus, // NEW: Import the API function
  updateUserName, // NEW: Import the update user name API
} from '@service/apis';
// import NotificationProvider from '@components/NotificationCenter/components/NotificationProvider';

import {
  // urlTabMap,
  // urlMap,
  checkUserOnSamePage,
  beforeJumpOnCommentTag,
  // handleLinkFromEmail,
} from '@components/directUser/data';
import { projectRole } from '@model';
import PermissionCheck from '@components/permissionCheck/PermissionCheck';
import alert from '@components/alert';
import GlobalBanner from '@components/globalBanner/GlobalBanner';
import EmailVerification from '@components/EmailVerification';
import { filterXSS } from 'xss';

// NEW: Import ProfileModal
import ProfileModal from '@components/profileModal';
import ActiveSessionsModal from '@components/activeSessionsModal';
import {
  getOtherSessions,
  isActiveSessionsPromptDismissed,
} from '@service/activeSessionsService';
import AiChatRoot from '../aiChat';
import TermsModal from '@modules/projects/projectsList/termsModal';

function isProjectDetailPath(pathname) {
  return Boolean(pathname && pathname.includes('project-detail'));
}

function isPermissionCacheValid(
  projectId,
  originAccessibleModules,
  permissionBundleProjectId,
) {
  return (
    Boolean(originAccessibleModules) &&
    permissionBundleProjectId != null &&
    String(permissionBundleProjectId) === String(projectId)
  );
}

const FullLoading = ({ isLoading }) =>
  isLoading && (
    <div className="loading-wrapper-fullscreen">
      <Loading tip="loading..." />
    </div>
  );

const getRoleControl = (userInfo = {}) => {
  let role = '';
  // userInfo.role = 'client';
  switch (userInfo.role) {
    case 'admin':
      role = 'role-admin';
      break;

    case 'internal':
      role = 'role-internal';
      break;

    case 'client':
      role = 'role-client';
      break;

    default:
      role = 'role-client';
      break;
  }

  return role;
};

function setProjectInfoToStorage(location) {
  const { projectId } = getProjectInfoFromLocation(location);
  if (projectId) {
    setSessionStorage('currentId', projectId);
  }
  // if (projectName) {
  //   window.SessionStorage.setItem('projectName', projectName);
  // }
}

class AppContainer extends Component {
  state = {
    accessToken: null, // NEW: State to store access token
    profileStatus: null, // NEW: State to store profile status
    profileModalLoading: false,
    termsResolved: false,
  };

  constructor(props) {
    super(props);
    setProjectInfoToStorage(props.history.location);

    // NEW: Create ref for profile modal
    this.profileModalRef = React.createRef();
    this.activeSessionsModalRef = React.createRef();
  }

  static getDerivedStateFromProps(props, state) {
    //get current project id when refesh page

    const currentId = getSessionStorage('currentId');
    if (!currentId) {
      // const { projectId: currentId, projectName } = getProjectInfoFromLocation(props.history.location);
      // currentId && window.SessionStorage.setItem('currentId', currentId);
      // projectName &&
      //   window.SessionStorage.setItem('projectName', projectName);
      setProjectInfoToStorage(props.history.location);
    }

    if (!props.currentId && currentId && currentId !== 'null') {
      props.changeCurrentId(currentId);
    }

    return state;
  }

  componentDidMount() {
    // Do not call getConfig or any project APIs until terms are accepted
    this.props.getUserInfo().then(async () => {
      const {
        originAccessibleModules,
        changePermissionLoading,
        location: { pathname },
      } = this.props;
      const { projectId } = getProjectInfoFromLocation(
        this.props.history.location,
      );

      // Resolve terms acceptance first; backend returns 401 for project/list APIs until accepted
      const accepted = await this.props.getTermsAcceptance();
      this.setState({ termsResolved: true });
      const termsAccepted = accepted === true;

      if (!termsAccepted) {
        changePermissionLoading(false);
        return;
      }

      // Only after terms accepted: config, theme, project data, profile check
      this.props.getConfig();
      this.props.getSystemColorTheme();
      this.checkAccessTokenAndFetchProfile();

      if (isValidProjectId(projectId) && !originAccessibleModules) {
        this.fetchPermissionData(projectId);
      } else if (!projectId || !isProjectDetailPath(pathname)) {
        changePermissionLoading(false);
      }

      // Check email verification AFTER getUserInfo completes
      if (
        window.location.pathname.includes('/settings') ||
        window.location.pathname.includes('/issue-list') ||
        window.location.pathname.includes('/projects/setting')
      ) {
        if (
          this.props.userInfo &&
          !isEmailVerifiedOrBypassed(this.props.userInfo)
        ) {
          const redirectUrl = window.location.href;
          this.props.history.replace('/projects/list');
          this.emailVerRef &&
            this.emailVerRef.show({
              callback: async () => {
                await this.props.getUserInfo();
                window.location.href = filterXSS(redirectUrl);
              },
            });
        }
      }
    });

    this.props.setEmailVerifyModalRef &&
      this.props.setEmailVerifyModalRef(this.emailVerRef);
  }

  clearBootstrapLoading = () => {
    const { changePermissionLoading, changeLoading } = this.props;
    changePermissionLoading(false);
    changeLoading(false);
  };

  initializeAfterAuth = async () => {
    const {
      changePermissionLoading,
      changeLoading,
      location: { pathname },
    } = this.props;
    const { projectId } = getProjectInfoFromLocation(
      this.props.history.location,
    );

    const accepted = await this.props.getTermsAcceptance();
    this.setState({ termsResolved: true });
    const termsAccepted = accepted === true;

    if (!termsAccepted) {
      changePermissionLoading(false);
      changeLoading(false);
      return;
    }

    this.props.getConfig();
    this.props.getSystemColorTheme();
    this.checkAccessTokenAndFetchProfile();
    await this.checkAndShowActiveSessions();

    const { originAccessibleModules, permissionBundleProjectId } = this.props;
    const onProjectDetail = isProjectDetailPath(pathname);
    const cacheValid = isPermissionCacheValid(
      projectId,
      originAccessibleModules,
      permissionBundleProjectId,
    );

    if (isValidProjectId(projectId) && onProjectDetail && !cacheValid) {
      await this.fetchPermissionData(projectId);
    } else {
      changePermissionLoading(false);
      changeLoading(false);
    }

    this.checkEmailVerificationOnRestrictedPaths();
  };

  checkAndShowActiveSessions = async () => {
    try {
      const data = await this.props.fetchActiveSessions();
      const sessions = data?.sessions || this.props.activeSessions || [];
      const currentSessionId =
        data?.currentSessionId || this.props.currentSessionId;
      const otherSessions = getOtherSessions(sessions, currentSessionId);

      if (
        otherSessions.length > 0 &&
        !isActiveSessionsPromptDismissed() &&
        this.activeSessionsModalRef.current
      ) {
        this.activeSessionsModalRef.current.show();
      }
    } catch (error) {
      console.error('Error checking active sessions:', error);
    }
  };

  checkEmailVerificationOnRestrictedPaths = () => {
    if (
      !window.location.pathname.includes('/settings') &&
      !window.location.pathname.includes('/issue-list') &&
      !window.location.pathname.includes('/projects/setting')
    ) {
      return;
    }
    if (
      this.props.userInfo &&
      !isEmailVerifiedOrBypassed(this.props.userInfo)
    ) {
      const redirectUrl = window.location.href;
      this.props.history.replace('/projects/list');
      this.emailVerRef &&
        this.emailVerRef.show({
          callback: async () => {
            await this.props.getUserInfo();
            window.location.href = filterXSS(redirectUrl);
          },
        });
    }
  };

  resolveProjectIdForPermission = () => {
    const { pathname } = this.props.location;
    const { projectId: projectIdFromUrl } = getProjectInfoFromLocation(
      this.props.history.location,
    );
    const projectIdFromStorage = getSessionStorage('currentId');
    const onProjectDetail = isProjectDetailPath(pathname);

    if (projectIdFromUrl && projectIdFromUrl !== 'null') {
      return projectIdFromUrl;
    }
    if (
      onProjectDetail &&
      projectIdFromStorage &&
      projectIdFromStorage !== 'null'
    ) {
      return projectIdFromStorage;
    }
    return null;
  };

  shouldFetchPermissionData = (projectId) => {
    if (!isValidProjectId(projectId)) {
      return false;
    }
    const { pathname } = this.props.location;
    if (!isProjectDetailPath(pathname)) {
      return false;
    }
    const { originAccessibleModules, permissionBundleProjectId } = this.props;
    return !isPermissionCacheValid(
      projectId,
      originAccessibleModules,
      permissionBundleProjectId,
    );
  };

  // NEW: Method to check access token and fetch profile status
  checkAccessTokenAndFetchProfile = async () => {
    try {
      // Check if accessToken exists in localStorage
      const accessToken = localStorage.getItem('accessToken');

      console.log('=== Access Token Check ===');
      console.log('Access Token exists:', !!accessToken);

      if (accessToken) {
        // Save access token to state
        this.setState({ accessToken });

        console.log('Access Token found, calling checkProfileStatus API...');

        // Make API call to check profile status
        const response = await checkProfileStatus();

        console.log('=== Profile Status API Response ===');
        console.log('Response:', response);

        // Save profile status to state
        this.setState({ profileStatus: response });

        // NEW: Check if profile is incomplete and show modal
        // Adjust this condition based on your API response structure
        if (response && !response.profileCompleted) {
          this.showProfileModal();
        }
      } else {
        console.log('No access token found in localStorage');
      }
    } catch (error) {
      console.error('Error checking profile status:', error);
    }
  };

  // NEW: Method to show profile modal
  showProfileModal = (initialValues = {}) => {
    if (this.profileModalRef.current) {
      this.profileModalRef.current.show(initialValues);
    }
  };

  // NEW: Method to handle profile form submission
  handleProfileSubmit = async (values) => {
    console.log('Profile submitted with values:', values);

    this.setState({ profileModalLoading: true });

    try {
      // Prepare the data for API
      const payload = {
        firstName: values.firstName.trim(),
        lastName: values.lastName.trim(),
      };

      console.log('Calling updateUserName API with payload:', payload);

      // Call the updateUserName API
      const response = await updateUserName(payload);

      console.log('updateUserName API response:', response);

      // Refresh user info after successful profile update
      await this.props.getUserInfo();

      console.log('Profile saved successfully!');

      // Update the profile status in state
      this.setState((prevState) => ({
        profileStatus: {
          ...prevState.profileStatus,
          firstName: values.firstName,
          lastName: values.lastName,
          isProfileIncomplete: false,
        },
      }));

      return response;
    } catch (error) {
      console.error('Error saving profile:', error);
      throw error; // Re-throw to let modal handle the error
    } finally {
      this.setState({ profileModalLoading: false });
    }
  };

  async fetchPermissionData(projectId) {
    const {
      getCustomizedModules,
      getAccessibleModules,
      getProjectBasicInfo,
      fetchAcceleratingTransition,
      changePermissionLoading,
    } = this.props;

    if (!this._permissionFetchByProject) {
      this._permissionFetchByProject = {};
    }
    if (this._permissionFetchByProject[projectId]) {
      return this._permissionFetchByProject[projectId];
    }

    const work = (async () => {
      changePermissionLoading(true);
      try {
        await getProjectBasicInfo(projectId);
        await getCustomizedModules(projectId);
        await getAccessibleModules(projectId);
        if (getValueFromSearchParam('from').from === 'tiles') {
          await fetchAcceleratingTransition(projectId);
        }
      } catch (e) {
        console.log(e);
        return alert.error({
          content: 'Fail to load permission data, please try again later',
        });
      } finally {
        changePermissionLoading(false);
      }
    })();

    this._permissionFetchByProject[projectId] = work;
    try {
      await work;
    } finally {
      if (this._permissionFetchByProject[projectId] === work) {
        delete this._permissionFetchByProject[projectId];
      }
    }
  }

  // componentDidMount() {
  //   return alert.error({
  //     content: 'Fail to load permission data, please try again later',
  //   });
  // }

  getCurrentRoute(routes) {
    const { location } = this.props;
    const { pathname = '' } = location;
    const pathArr = pathname.split('/');
    const subPathName = pathArr.length ? pathArr[pathArr.length - 1] : '';

    const currentRoute = _.find(routes, {
      path: subPathName,
    });
    return currentRoute;
  }

  getLabel(routes) {
    const currentRoute = this.getCurrentRoute(routes);

    const { path } = currentRoute || routes[0];

    return path;
  }

  /** Resolves project UUID for isolated AI chat (URL takes precedence over Redux). */
  getAiChatProjectId() {
    const { currentId } = this.props;
    const { projectId: fromUrl } = getProjectInfoFromLocation(
      this.props.history.location,
    );
    const raw =
      fromUrl && fromUrl !== 'null'
        ? fromUrl
        : currentId && currentId !== 'null'
        ? currentId
        : null;
    return isValidProjectId(raw) ? raw : null;
  }

  render() {
    const {
      match,
      history,
      isLoading = true,
      currentId,
      userInfo,
      // permission,
      hideScrollBar,
      // sectionsPermission,
      // internalSectionsPermission,
      companyInfo,
      accessibleModules = {},
      permissionLoading,
      originAccessibleModules,
      customizedModules,
      urlTabMap,
      urlMap,
    } = this.props;

    const { profileModalLoading, termsResolved } = this.state; // NEW: Destructure state
    const { termsAccepted } = this.props;
    const termsNotAccepted = termsAccepted !== true;
    const { pathname } = history.location;

    // userInfo.role = 'client';
    const isPwcReadOnly =
      companyInfo?.currentUserPermission === projectRole['View-Only'];
    const routes = getRoutes({
      isClient: userInfo?.role === 'client',
      // permission,
      // sectionsPermission,
      // isSingleCompany: companyInfo.isSingleCompany,
      singleCompanyInstance: companyInfo.singleCompanyInstance,
      // internalSectionsPermission,
      accessibleModuleList: originAccessibleModules?.moduleList,
      customizedModules,
    });

    // Both providers no-op on a falsy projectId, so withholding it keeps them
    // from calling project APIs while the user is blocked by the T&C modal.
    const providerProjectId = termsNotAccepted ? null : this.props.currentId;

    return (
      <NotificationProvider
        app="MA"
        projectId={providerProjectId}
        name={`${userInfo.given_name || ''} ${userInfo.family_name || ''}`}
        email={userInfo.email}
        isClient={userInfo?.role === 'client'}
        accessibleModules={accessibleModules}
        urlMap={urlMap}
        checkUserOnSamePage={checkUserOnSamePage}
        beforeJump={beforeJumpOnCommentTag}
        history={history}
        getCommentStatus={getCommentStatus}
        updateCommentStatus={updateCommentStatus}
        getProjectMember={getProjectMember}
        dateFormatter={formatUserLocalDate}
      >
        <CommentProvider
          app="MA"
          projectId={providerProjectId}
          fetchProjectUser={async (v) => {
            const res = await API.getProjectMember(this.props.currentId);
            return res?.userList || [];
          }}
          name={`${userInfo.given_name || ''} ${userInfo.family_name || ''}`}
          email={userInfo.email}
          accessibleModules={accessibleModules}
          urlTabMap={urlTabMap}
          urlMap={urlMap}
          checkUserOnSamePage={checkUserOnSamePage}
          beforeJump={beforeJumpOnCommentTag}
          history={history}
          dateFormatter={formatUserLocalDate}
        >
          <FullLoading isLoading={isLoading || permissionLoading} />

          <div
            className={classnames(
              {
                'app-container': true,
                'app-filter': isLoading,
                'hide-scroll': hideScrollBar,
                'terms-not-accepted-block': termsNotAccepted,
              },
              getRoleControl(userInfo),
            )}
          >
            <AppHeader
              routes={routes}
              basePath={match.path}
              history={history}
              label={this.getLabel(routes)}
            />

            <div className="app-body">
              <div
                className={`app-content ${
                  isPwcReadOnly ? 'role-pwc-readonly' : ''
                }`}
              >
                <GlobalBanner />
                <Switch>
                  {_.map(routes, (route, i) => {
                    const {
                      path,
                      main: Main,
                      disabled,
                      routes,
                      permission,
                    } = route;

                    if (disabled) {
                      return null;
                    }
                    // console.log({ path: `${match.path}${path}`, Main });

                    return (
                      <Route
                        key={i}
                        path={`${match.path}${path}`}
                        render={(props) => (
                          <PermissionCheck
                            {...props}
                            routes={routes}
                            permission={permission}
                          >
                            <Main {...props} routes={routes} />
                          </PermissionCheck>
                        )}
                      />
                    );
                  })}
                  {!permissionLoading && !isProjectDetailPath(pathname) ? (
                    <Redirect path="*" to={`${match.path}projects/list`} />
                  ) : null}
                </Switch>
              </div>
              <div className="app-sidebar">
                <SiderBar
                  routes={routes}
                  rootPath={match.path}
                  currentId={currentId}
                />
              </div>
            </div>

            <AppFooter />

            {!termsNotAccepted ? (
              <AiChatRoot projectId={this.getAiChatProjectId()} />
            ) : null}

            <EmailVerification ref={(r) => (this.emailVerRef = r)} />

            {/* NEW: Profile Modal */}
            <ProfileModal
              ref={this.profileModalRef}
              onSubmit={this.handleProfileSubmit}
              loading={profileModalLoading}
            />

            <ActiveSessionsModal ref={this.activeSessionsModalRef} />
          </div>
          {termsNotAccepted && (
            <div
              className="terms-blocking-overlay"
              aria-hidden="true"
              role="presentation"
            />
          )}
          <TermsModal
            visible={termsResolved && termsNotAccepted}
            onAccept={this.props.acceptTerms}
          />
        </CommentProvider>
      </NotificationProvider>
    );
  }

  componentDidUpdate(prevProps) {
    // When user just accepted T&C (e.g. first login), run post-terms-acceptance flow so profile modal can show
    const termsJustAccepted =
      prevProps.termsAccepted !== true && this.props.termsAccepted === true;
    if (termsJustAccepted) {
      void this.initializeAfterAuth();
    }

    if (this.props.location.pathname !== prevProps.location.pathname) {
      setTimeout(() => {
        window.scrollTo({ top: 0, behavior: 'smooth' });
      });
    }

    // Project APIs are rejected until terms are accepted. Without this guard the
    // failed calls never populate their caches, so every re-render retries them
    // and stacks error alerts behind the T&C modal.
    if (this.props.termsAccepted !== true) {
      return;
    }

    if (
      this.props.currentId &&
      this.props.currentId !== 'null' &&
      prevProps.companyInfo.projectId !== this.props.currentId
    ) {
      this.props.getProjectCompanyInfoId();
    }

    // When user is on project-detail but permission data not loaded yet (e.g. client
    // redirected from list — Redux currentId may not have updated), fetch by URL so
    // PermissionCheck can pass (originAccessibleModules is required).
    const resolvedProjectId = this.resolveProjectIdForPermission();
    const needsPermissionData =
      this.shouldFetchPermissionData(resolvedProjectId);

    if (needsPermissionData) {
      this.fetchPermissionData(resolvedProjectId);
    } else {
      const currentId = this.props.currentId;
      const hasProjectId = currentId && currentId !== 'null';
      if (hasProjectId && prevProps.currentId !== currentId) {
        if (this.shouldFetchPermissionData(currentId)) {
          this.fetchPermissionData(currentId);
        }
      }
    }
  }
}

AppContainer.defaultProps = { isLoading: false, currentId: null };

AppContainer.propTypes = {
  isLoading: PropTypes.bool,
  currentId: PropTypes.string,
};

const mapStateToProps = (state) => ({
  isLoading: state.common.isLoading || state.common.systemThemeLoading,
  currentId: state.common.currentId,
  userInfo: state.login.userInfo,
  termsAccepted: state.login?.userInfo?.accepted,
  activeSessions: state.login.activeSessions,
  currentSessionId: state.login.currentSessionId,
  permissionLoading: state.projects.permissionLoading,
  originAccessibleModules: state.projects.originAccessibleModules,
  permissionBundleProjectId: state.projects.permissionBundleProjectId,
  // permission: state.projects.userPermission,
  // sectionsPermission: state.projects.sectionsPermission,
  // internalSectionsPermission: state.projects.internalSectionsPermission,
  hideScrollBar: state.common.hideScrollBar,
  companyInfo: state.common.projectCompanyInfo,
  urlMap: state.common.urlMap,
  urlTabMap: state.common.urlTabMap,
  accessibleModules: state.projects.accessibleModules,
  customizedModules: state.projects.customizedModules,
  emailVerModalRef: state.common.emailVerModalRef,
});

const mapDispatchToProps = (dispatch) => ({
  saveUserInfo(data) {
    dispatch(actions.saveUserInfo(data));
  },
  changeCurrentId(id) {
    dispatch(actions.changeCurrentId(id));
  },
  getConfig() {
    dispatch(actions.getConfig());
  },
  getUserInfo() {
    return dispatch(actions.getUserInfo);
  },
  getTermsAcceptance() {
    return dispatch(actions.getTermsAcceptance());
  },
  acceptTerms() {
    dispatch(actions.acceptTerms(true));
  },

  // getMoreUserInfo(userInfo) {
  //   dispatch(actions.getMoreUserInfo(userInfo));
  // saveUserPermission(permission = []) {
  //   dispatch(actions.saveUserPermission(permission));
  // },
  getProjectCompanyInfoId(projectId) {
    let currentId = getSessionStorage('currentId');
    currentId = currentId && currentId !== 'null' ? currentId : null;
    dispatch(actions.getProjectInfo(projectId || currentId));
  },
  getCustomizedModules(p) {
    return dispatch(actions.getCustomizedModules(p));
  },
  getAccessibleModules(id) {
    return dispatch(actions.getAccessibleModules(id));
  },
  // changePermissionLoaded(bool) {
  //   dispatch(actions.changePermissionLoaded(bool));
  // },
  changePermissionLoading(bool) {
    dispatch(actions.changePermissionLoading(bool));
  },
  changeLoading(bool) {
    dispatch(actions.changeLoading(bool));
  },
  fetchAcceleratingTransition(id) {
    return dispatch(actions.fetchAcceleratingTransition(id));
  },
  getProjectBasicInfo(id) {
    return dispatch(actions.getProjectInfo(id));
  },
  getSystemColorTheme() {
    return dispatch(actions.getSystemColorTheme());
  },
  setEmailVerifyModalRef(ref) {
    return dispatch(actions.setEmailVerifyModalRef(ref));
  },
  fetchActiveSessions() {
    return dispatch(actions.fetchActiveSessions());
  },
});

export default connect(
  mapStateToProps,
  mapDispatchToProps,
)(checkLogin(AppContainer));
